import { createAction, createSlice } from '@reduxjs/toolkit';

import { MODULE_NAME } from './constants';

const initialState = {
	loadedScripts: [],
	loadingErrors: {},
};

const slice = createSlice({
	name: MODULE_NAME,
	initialState,
	reducers: {
		scriptLoaded(state, { payload: scriptName }) {
			state.loadedScripts.push(scriptName);
		},
		scriptLoadError(state, { payload: { error, scriptName } }) {
			// eslint-disable-next-line no-param-reassign
			state.loadingErrors[scriptName] = error;
		},
	},
});

export const { scriptLoadError, scriptLoaded } = slice.actions;

export const loadScript = createAction(`${MODULE_NAME}/loadScript`);

export default slice.reducer;
